import { render, staticRenderFns } from "./ShowPriceCajaField.vue?vue&type=template&id=6fea8941&scoped=true&"
import script from "./ShowPriceCajaField.vue?vue&type=script&lang=js&"
export * from "./ShowPriceCajaField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fea8941",
  null
  
)

export default component.exports